import React from 'react';

const Logo = props => {
  const { url } = props;

  return url ? <img src={url} style={{ width: '260px' }} /> : <div />;
};

export default Logo;
